import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WerkstattKonfigurator from "./WerkstattKonfigurator";
import HexagonKonfigurator from "./HexagonKonfigurator";
import HexagonBundleTest from "./HexagonConfigurator.bundle";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HexagonKonfigurator />} />
        <Route path="/werkstatt" element={<WerkstattKonfigurator />} />
        <Route path="/hexagon-test" element={<HexagonBundleTest />} />

      </Routes>
    </Router>
  );
}

export default App;
